/* eslint-disable */
/* TODO: If you edit this file remove eslint-disable and fix linting errors in this file. */
require('moment/moment');
const extendMoment = require('moment-range/dist/moment-range').extendMoment;
const momentTz = require('moment-timezone/builds/moment-timezone-with-data');
// @ts-ignore
window.moment = extendMoment(momentTz);
